import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import Stethoscope from './Stethoscope';

import './index.css';

export default (element) => {
  const medias = {};
  Object.keys(element.dataset).forEach((key) => {
    medias[key] = element.dataset[key];
  });

  const root = createRoot(element);
  root.render(
    <ErrorBoundary>
      <Stethoscope
        medias={medias}
      />
    </ErrorBoundary>,
  );
};
